'use client'

import { useContext, useEffect, useMemo, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { GlobalContext } from 'src/components/layout/GlobalContext'
import { getHreflangLinks } from 'src/i18n/client/getHreflangLinks'

export default function LangChangerScope({ path = '/', options = null, hreflang = true, children, ...props }) {
  const { setLangChangerState, siteOrigin, siteDefaultLocale, currentLocale } = useContext(GlobalContext)
  const pathname = usePathname()
  const scopeId = useRef(Symbol('lang-changer-scope'))

  const serializedOptions = useMemo(() => {
    if (typeof options === 'string') {
      return options
    }

    return options ? JSON.stringify(options) : null
  }, [options])

  // React przenosi <link> do <head>, więc ścieżki przełącznika języka służą też jako hreflang.
  const hreflangLinks = useMemo(
    () =>
      hreflang
        ? getHreflangLinks({
            origin: siteOrigin,
            locale: currentLocale,
            pathname,
            defaultLocale: siteDefaultLocale,
            path,
            options: serializedOptions,
          })
        : [],
    [hreflang, siteOrigin, currentLocale, pathname, siteDefaultLocale, path, serializedOptions],
  )

  useEffect(() => {
    setLangChangerState?.({
      id: scopeId.current,
      path: path || '/',
      options: serializedOptions,
    })

    return () => {
      setLangChangerState?.((currentState) => {
        return currentState?.id === scopeId.current ? null : currentState
      })
    }
  }, [path, serializedOptions, setLangChangerState])

  return (
    <div {...props}>
      {hreflangLinks.map(({ hrefLang, href }) => (
        <link key={hrefLang} rel="alternate" hrefLang={hrefLang} href={href} />
      ))}
      {children}
    </div>
  )
}
